export default __webpack_public_path__ + "static/media/footerImage1.b7584d36.jpeg";